<div class="bg-gray-50 min-h-screen p-3 sm:p-4 lg:p-6 overflow-x-hidden">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="mb-6">
    <h1 class="text-2xl font-semibold text-gray-900">
      Liste des apprenants
    </h1>
    <p class="text-sm text-gray-500 mt-1">
      Consultez et gérez les apprenants et leurs certifications
    </p>
  </div>


  <div class="bg-white border rounded-xl shadow-sm p-4 mb-6 w-full">

    <div class="flex flex-col lg:flex-row lg:items-center gap-4 w-full">

      <!-- LEFT -->
      <div class="flex flex-wrap gap-2 bg-gray-100 p-1 rounded-lg flex-1 min-w-0">

        <button class="px-4 py-2.5 text-sm font-medium rounded-md whitespace-nowrap"
          [class.bg-white]="viewMode === 'ALL'" (click)="setMode('ALL')">Tous</button>

        <button class="px-4 py-2.5 text-sm font-medium rounded-md whitespace-nowrap"
          [class.bg-white]="viewMode === 'FEMALE'" (click)="setMode('FEMALE')">Femmes</button>

        <button class="px-4 py-2.5 text-sm font-medium rounded-md whitespace-nowrap"
          [class.bg-white]="viewMode === 'MALE'" (click)="setMode('MALE')">Hommes</button>

        <button class="px-4 py-2.5 text-sm font-medium rounded-md whitespace-nowrap"
          [class.bg-white]="viewMode === 'CERTIFIED'" (click)="setMode('CERTIFIED')">Certifiés</button>

        <button class="px-4 py-2.5 text-sm font-medium rounded-md whitespace-nowrap"
          [class.bg-white]="viewMode === 'ENHANCED'" (click)="setMode('ENHANCED')">Renforcés</button>

        <button class="px-4 py-2.5 text-sm font-medium rounded-md whitespace-nowrap"
          [class.bg-white]="viewMode === 'INSERES'" (click)="setMode('INSERES')">En situation d'emploi</button>

      </div>

      <!-- RIGHT -->
      <div class="flex gap-2 w-full lg:w-auto lg:flex-shrink-0">

        <input type="text" class="w-full lg:w-48 px-3 py-2.5 text-sm border rounded-lg" placeholder="Rechercher..."
          (input)="filterText($event)" />

        <select class="w-full lg:w-48 px-3 py-2.5 text-sm border rounded-lg" [(ngModel)]="selectedCertificateId"
          (change)="onCertificateChange()">

          <option value="-1">Tous les certificats</option>

          <option *ngFor="let certifcate of certifcateOption" [value]="certifcate.id">
            {{ certifcate.name }}
          </option>

        </select>

      </div>

    </div>
  </div>

  <!-- TABLE  -->
  <div class="bg-white border rounded-xl shadow-sm overflow-hidden tab-apprenants">

    <table mat-table [dataSource]="dataSource" class="w-full">


      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nom & Prénom</th>
        <td mat-cell *matCellDef="let row" data-label="Nom" class="font-semibold">
          {{ row.fullname }}
        </td>
      </ng-container>


      <ng-container matColumnDef="sexe">
        <th mat-header-cell *matHeaderCellDef>Genre</th>
        <td mat-cell *matCellDef="let row" data-label="Genre">
          <span class="px-2 py-1 rounded-lg" [class.bg-blue-100]="row.sexe === 'M'"
            [class.text-blue-700]="row.sexe === 'M'" [class.bg-pink-100]="row.sexe === 'F'"
            [class.text-pink-700]="row.sexe === 'F'">
            {{ row.sexe || 'N/A' }}
          </span>
        </td>
      </ng-container>


      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let row" data-label="Email">
          {{ row.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="nombrecours">
        <th mat-header-cell *matHeaderCellDef>Nombre de certificats</th>
        <td mat-cell *matCellDef="let row">
          {{ certificationData?.certificatNumber || ''}}
        </td>
      </ng-container>


      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="text-center !text-center">Action</th>
        <td mat-cell *matCellDef="let row" data-label="Action" class="text-center action-cell">
          <button (click)="openDetails(row)"
            class="w-9 h-9 sm:w-10 sm:h-10 rounded-xl hover:bg-gray-100 active:scale-95 transition flex items-center justify-center mx-auto">
            <svg class="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-width="1.5"
                d="M2.036 12.322C3.423 7.51 7.36 4.5 12 4.5s8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5S3.423 16.49 2.036 12.322Z" />
              <path stroke-width="1.5" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            </svg>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <div *ngIf="!(dataSource.filteredData ?? dataSource.data)?.length" class="p-6 text-center text-sm text-gray-500">
      Aucun apprenant trouvé.
    </div>

    <!-- PAGINATOR -->
    <div class="border-t p-2">
      <mat-paginator [length]="totalElements" [pageSize]="pageSize" [pageIndex]="currentPage"
        [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
      </mat-paginator>
    </div>

  </div>

</div>



<div *ngIf="popupVisible"
  class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-2 sm:p-4">

  <div class="bg-white w-full sm:max-w-4xl rounded-2xl shadow-xl overflow-hidden max-h-[95vh] overflow-y-auto">

    <!-- HEADER -->
    <div class="flex justify-between items-center px-4 sm:px-6 py-3 border-b">
      <h2 class="text-base sm:text-lg font-semibold">
        {{ ligneDetails?.firstname }} {{ ligneDetails?.lastname }}
      </h2>

      <button (click)="closeModal()" class="text-gray-500 hover:text-black text-xl">
        ✕
      </button>
    </div>

    <!-- BODY -->
    <div class="p-4 sm:p-6 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-sm">

      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500 ">Nom complet</div>
        <div class="font-medium">
          {{ ligneDetails?.lastname }} {{ ligneDetails?.firstname }}
        </div>
      </div>

      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500">Email</div>
        <div class="font-medium break-all">
          {{ ligneDetails?.email }}
        </div>
      </div>

      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500 ">Genre</div>
        <div class="font-medium">{{ ligneDetails?.sexe }}</div>
      </div>

      <div class="p-3 bg-gray-50 rounded-lg">
        <div class="text-gray-500">Ville</div>
        <div class="font-medium">{{ ligneDetails?.city }}</div>
      </div>
      <div class="p-3 bg-gray-50 rounded-lg mt-2">
        <div class="text-gray-500 ">Nombre de certificats</div>
        <div class="font-medium">
          {{ certificationData?.certificatNumber|| 0 }}
        </div>
      </div>
    </div>

    <!-- CERTIFICATS TABLE -->
    <table class="w-full min-w-[700px] text-sm border rounded-lg overflow-hidden">

      <thead class="bg-gray-100 text-left">
        <tr>
          <th class="p-3">Nom certificat</th>
          <th class="p-3">Id certificat</th>
          <th class="p-3">Cohorte</th>
          <th class="p-3">Certifié</th>
          <th class="p-3">Renforcé</th>
          <th class="p-3">Inséré</th>
        </tr>
      </thead>

      <tbody>

        <tr *ngFor="let c of certificationRows" class="border-t hover:bg-gray-50">

          <td class="p-3">
            {{ c.nameCertificate || '-' }}
          </td>

          <td class="p-3">
            {{ c.idCertificate || '-' }}
          </td>

          <td class="p-3">
            {{ c.cohort || '-' }}
          </td>

          <!-- CERTIFIÉ -->
          <td class="p-3">
            <span class="px-2 py-1 rounded-full text-xs font-medium" [class.bg-green-100]="c.certified"
              [class.text-green-700]="c.certified">
              {{ c.certified ? 'Oui' : '-' }}
            </span>
          </td>


          <td class="p-3">
            <span class="px-2 py-1 rounded-full text-xs font-medium" [class.bg-blue-100]="c.enhanced"
              [class.text-blue-700]="c.enhanced">
              {{ c.enhanced ? 'Oui' : '-' }}
            </span>
          </td>


          <td class="p-3">
            <span class="px-2 py-1 rounded-full text-xs font-medium" [class.bg-purple-100]="c.inserted"
              [class.text-purple-700]="c.inserted">
              {{ c.inserted ? 'Oui' : '-' }}
            </span>
          </td>

        </tr>

      </tbody>

    </table>

    <!-- FOOTER -->
    <div class="px-4 sm:px-6 py-4 border-t flex justify-end">
      <button (click)="closeModal()"
        class="w-full sm:w-auto px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600">
        Fermer
      </button>
    </div>

  </div>
</div>